<!-- Modal Header -->
<div class="modal-header" style="background: #1a1a1a; color: white; border-bottom: 3px solid #01abce; padding: 1rem 1.5rem;">
  <div class="d-flex align-items-center gap-3">
    <div class="d-flex align-items-center justify-content-center" 
         style="width: 40px; height: 40px; background: #01abce; border-radius: 8px;">
      <i class="fas fa-user-check" style="font-size: 1.2rem;"></i>
    </div>
    <div>
      <h4 class="modal-title mb-0" style="font-weight: 600; font-size: 1.1rem;">
        Revisión de Cliente
      </h4>
      <small class="text-muted" style="font-size: 0.85rem; color: #b0b0b0 !important;">
        Código: {{personCode}}
      </small>
    </div>
  </div>
  <button 
    type="button" 
    class="btn-close btn-close-white"
    (click)="closeModal()"
    aria-label="Cerrar"
    style="opacity: 1; font-size: 1.2rem;"
  ></button>
</div>

<!-- Modal Body -->
<div class="modal-body" style="padding: 0; background-color: #f8f9fa; height: calc(100vh - 60px); overflow-y: auto;">
  <!-- Verificar si el componente existe -->
  <div *ngIf="personCode; else loadingTemplate">
    <app-contact-onboarding 
      [personCode]="personCode"
      [fromRevision]="fromRevision"
      [isModal]="true"
      (onComplete)="handleOnboardingComplete($event)"
      (onClose)="handleOnboardingClose()"
    ></app-contact-onboarding>
  </div>
  
  <!-- Template de carga -->
  <ng-template #loadingTemplate>
    <div class="d-flex justify-content-center align-items-center" style="min-height: 400px;">
      <div class="text-center p-4">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="text-muted mb-2">Cargando información del cliente...</p>
        <p class="text-muted small mb-3">Código: <code>{{personCode}}</code></p>
        <div class="alert alert-info d-inline-block" role="alert">
          <i class="fas fa-info-circle me-2"></i>
          Si el error persiste, verifica que el código del cliente sea correcto
        </div>
      </div>
    </div>
  </ng-template>
</div>

<!-- Footer con acciones -->
<div class="modal-footer" style="background: #ffffff; border-top: 1px solid #e0e0e0; padding: 1rem 1.5rem;">
  <div class="d-flex justify-content-between align-items-center w-100">
    <small class="text-muted d-flex align-items-center gap-2">
      <i class="fas fa-info-circle" style="color: #01abce;"></i>
      <span>Presiona <kbd>ESC</kbd> o haz clic en el botón para cerrar</span>
    </small>
    <button 
      type="button" 
      class="btn btn-dark d-flex align-items-center gap-2" 
      (click)="closeModal()"
      style="padding: 0.5rem 1.5rem; border-radius: 6px; font-weight: 500;"
    >
      <i class="fas fa-times"></i>
      <span>Cerrar</span>
    </button>
  </div>
</div>

<!-- Loading Overlay (if needed) -->
<div *ngIf="false" class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75" style="z-index: 1050;">
  <div class="text-center">
    <div class="spinner-border text-primary mb-2" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="text-muted">Cargando información del cliente...</p>
  </div>
</div>
